import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import Disclaimer from "./sections/Disclaimer";
export default function HomePage() {
  return <div className="min-h-screen bg-background text-foreground">
      <Header />

      <main id="main-content">
        <Hero />
        <Disclaimer />
      </main>

      <Footer />
    </div>;
}